<template>
    <modal 
        v-model:show="modal" 
        type="mini" 
        modal-classes="modal-dialog-centered modal-sm" 
        transparent
        style="z-index: 9999"
    >
        <div class="spinner">
            <div v-for="i in 5" :key="i" :class="`rect${i}`" :style="{ backgroundColor: color.primary }"></div>
        </div>
    </modal>
</template>

<script>
import Modal from '../../argon/components/Modal'
import Card from '../../argon/components/Cards/Card'

export default {
    name: 'LoadingModal',
    components: {
        Modal,
        Card
    },
    props: {
      color: {
        type: Object,
        required: true
      }
    },
    computed: {
        modal: {
          get() {
            return this.$loading.state
          },
          set(value) {
            return;
          }
        }
    }
}
</script>

<style scoped>
.spinner {
  margin: 50px auto;
  width: 90px;
  height: 100px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  height: 100%;
  width: 6px;
  display: inline-block;
  margin: 0 2px;
  
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% { 
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% { 
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}
</style>
